import { Users, MapPin, MousePointerClick, Heart } from "lucide-react";
import { Card } from "@/components/ui/card";

export const AboutFeatures = () => {
  return (
    <section className="space-y-8">
      <h2 className="text-3xl font-semibold text-center">Why Choose Us</h2>
      <div className="grid md:grid-cols-2 gap-8">
        <Card className="p-6 space-y-4 hover:shadow-lg transition-shadow">
          <Users className="w-10 h-10 text-primary" />
          <h3 className="text-xl font-medium">Verified Professionals</h3>
          <p className="text-muted-foreground">
            We carefully vet each contractor to ensure they meet our high standards of quality and reliability.
          </p>
        </Card>
        
        <Card className="p-6 space-y-4 hover:shadow-lg transition-shadow">
          <MapPin className="w-10 h-10 text-primary" />
          <h3 className="text-xl font-medium">Local Expertise</h3>
          <p className="text-muted-foreground">
            Our contractors know Oklahoma City inside and out, ensuring you get service tailored to our unique climate and conditions.
          </p>
        </Card>
        
        <Card className="p-6 space-y-4 hover:shadow-lg transition-shadow">
          <MousePointerClick className="w-10 h-10 text-primary" />
          <h3 className="text-xl font-medium">Easy to Use</h3>
          <p className="text-muted-foreground">
            Our platform makes it simple to find the right professional for any job, big or small.
          </p>
        </Card>
        
        <Card className="p-6 space-y-4 hover:shadow-lg transition-shadow">
          <Heart className="w-10 h-10 text-primary" />
          <h3 className="text-xl font-medium">Customer First</h3>
          <p className="text-muted-foreground">
            We prioritize your satisfaction and work hard to ensure you have the best possible experience.
          </p>
        </Card>
      </div>
    </section>
  );
};